import axios from 'axios'

export default {
  async refresh (project, params) {
    try {
      const response = await axios.get(`/projects/${project}/refresh`, { params })

      if (response.data.status === 'success') {
        return _.get(response, 'data.data')
      } else {
        console.error(response)
      }
    } catch (err) {
      console.error(err)
    }
    return false
  },
  async getProjectOutline (project) {
    try {
      const response = await axios.get(`/projects/${project}/outline`)

      if (response.data.status === 'success') {
        return _.get(response, 'data.data')
      } else {
        console.error(response)
      }
    } catch (err) {
      console.error(err)
    }
    return false
  },
  async getDataObject (url, dataObject = '') {
    try {
      const response = await axios.get(`${url}/data/${dataObject}`)

      if (response.data.status === 'success') {
        return _.get(response, 'data.data')
      } else {
        console.error(response)
      }
    } catch (err) {
      console.error(err)
    }
    return false
  },
  async getRevisions (dataObject) {
    try {
      const response = await axios.get(`/data/${dataObject}/revisions`)

      if (response.data.status === 'success') {
        return _.get(response, 'data.data')
      } else {
        console.error(response)
      }
    } catch (err) {
      console.error(err)
    }
    return false
  },
  async getRevision (dataObject, revision) {
    try {
      const response = await axios.get(`/data/${dataObject}/revisions/${revision}`)

      if (response.data.status === 'success') {
        return _.get(response, 'data.data')
      } else {
        console.error(response)
      }
    } catch (err) {
      console.error(err)
    }
    return false
  },
  async update (url, data) {
    try {
      const response = await axios.patch(url, data)

      if (response.data.status === 'success') {
        return _.get(response, 'data.data')
      } else {
        console.error(response)
      }
    } catch (err) {
      console.error(err)
    }
    return false
  },
  async saveChanges (url, changeSet) {
    try {
      const response = await axios.post(`${url}/save`, changeSet)

      if (response.data.status === 'success') {
        return _.get(response, 'data.data')
      } else {
        console.error(response)
      }
    } catch (err) {
      console.error(err)
    }
    return false
  },
  async publish (project, learning = [], options = { }) {
    try {
      const response = await axios.post(`/projects/${project}/publish`, { learning, options })

      if (response.data.status === 'success') {
        return _.get(response, 'data')
      } else {
        console.error(response)
      }
    } catch (err) {
      console.error(err)
    }
  },
  async syncDriver (project, options = { }) {
    try {
      const response = await axios.post(`/projects/${project}/sync-driver`, { options })

      if (response.data.status === 'success') {
        return _.get(response, 'data')
      } else {
        console.error(response)
      }
    } catch (err) {
      console.error(err)
    }
  },
  async syncProject (project, learning = [], options = { }) {
    try {
      const response = await axios.post(`/projects/${project}/sync`, { learning, options })

      if (response.data.status === 'success') {
        return _.get(response, 'data')
      } else {
        console.error(response)
      }
    } catch (err) {
      console.error(err)
    }
  },
  async syncLearning (learning, options = { }) {
    try {
      const response = await axios.post(`/learning/${learning}/sync`, { options })

      if (response.data.status === 'success') {
        return _.get(response, 'data')
      } else {
        console.error(response)
      }
    } catch (err) {
      console.error(err)
    }
  },
  async generateMissingDatasets(project_id, data = { }) {
    try {
      const response = await axios.post(`/projects/${project_id}/generate-datasets`, { data })

      if (response.data.status === 'success') {
        return _.get(response, 'data')
      } else {
        console.error(response)
      }
    } catch (err) {
        console.error(err)
    }
  }
}